import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')

export const state = {
  legalizations: {},
}

export const getters = {}

export const mutations = {
  LEGALIZATIONS(state, request) {
    state.legalizations = request
  },
}

export const actions = {
  init({ state, dispatch }) {},

  fetchLegalizationsAllData(context, query) {
    query = query || ''
    return axios
      .get(`${serverUrl}/api/legalization/${query}`)
      .then((response) => {
        const request = response.data
        context.commit('LEGALIZATIONS', request)
        return request
      })
  },

  fetchCreateLegalizations(context, payload) {
    let promise = null
    promise = axios.post(`${serverUrl}/api/legalization/`, payload)
    return promise.then((response) => {
      return response.data
    })
  },

  fetchEditLegalizationQuantity(context, formData) {
    let promise = null
    promise = axios.put(
      `${serverUrl}/api/legalization/${formData.id}/`,
      formData
    )
    return promise.then((response) => {
      return response.data
    })
  },

  fetchActivityHaveLegalization(context, idSchedule) {
    let promise = null
    promise = axios.get(`${serverUrl}/api/legalization/schedule/${idSchedule}/`)
    return promise.then((response) => {
      return response.data
    })
  },

  fetchProjectLegalization(context, idProject) {
    let promise = null
    promise = axios.get(`${serverUrl}/api/legalization/project/${idProject}/`)
    return promise.then((response) => {
      return response.data
    })
  },

}
